import { runtimeConfig } from "@src/runtime-config";
import { CLIENT_ID } from "@api/client-id";
import { CoreApiClient } from "@stellar/core-api-client";

/**
 * This is the new Core API client that is used to communicate with the Core API repo.
 * It is used to fetch data from the Core API and to send data to the Core API.
 */
export const faroCoreApiClient = new CoreApiClient({
  baseUrl: runtimeConfig.urls.apiBaseUrl,
  headers: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "X-Holobuilder-Component": CLIENT_ID,
  },
  // If the return type is different than what we expected, we log an assertion error.
  onLogAssertion: (message) => {
    // eslint-disable-next-line no-console
    console.error(message);
  },
});
